export enum FiltreAccueilPeriode
{
  SeptJours   = 'J7',
  TrenteJours = 'J30',
  TroisMois   = 'M3',
  DouzeJours  = 'M12'
}
